/** @jsx jsx */
import { useLingui } from '@lingui/react';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Badge from '../Badge/Badge';
import OnlineShopIcon from '../Badge/OnlineShopIcon';
import VideosIcon from '../Badge/VideosIcon';
import VirtualTastingIcon from '../Badge/VirtualTastingIcon';

export default function ProductBadge({ type, variant, direction, className }) {
  const { i18n } = useLingui();
  const Icon = icons[type] || icons.default;
  return (
    <Badge
      icon={<Icon {...(iconVariants[variant] || iconVariants.default)} />}
      direction={direction}
      className={className}
    >
      {i18n._(`productFeature.${type}`)}
    </Badge>
  );
}

const iconVariants = {
  onDark: { sx: { color: 'onPrimary' } },
  onPrimary: { sx: { color: 'primary' }, backgroundColor: 'white' },
  default: { sx: { color: 'primary' }, backgroundColor: 'white' },
};

const icons = {
  default: VirtualTastingIcon,
  webshop: OnlineShopIcon,
  videos: VideosIcon,
};

export const fragment = graphql`
  fragment MarketingActivityBadge on MarketingActivity {
    type
  }
`;
